import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import SampleData from "./sample-data";
import {IPower} from "./sample-data/power";
import {ITemperature} from "./sample-data/temperature";
import {IPitchAngles} from "./sample-data/pitch-angle";
import {IWind} from "./sample-data/wind";
import {ILines} from "./sample-data/lines";
import {IEvent} from "./sample-data/events";

interface ContentSliceState {
    power: IPower
    pitch_angles: IPitchAngles,
    temperature: ITemperature,
    wind: IWind,
    lines: ILines,
    events: IEvent[],
}

const initState: ContentSliceState = {
    power: SampleData.power,
    pitch_angles: SampleData.pitchAngle,
    temperature: SampleData.temperature,
    wind: SampleData.wind,
    lines: SampleData.lines,
    events: SampleData.events
}

const ContentSlice = createSlice({
    name: 'content',
    initialState: initState,
    reducers: {
        clearAllEvents: (state) => {
            state.events = [];
        },
        clearEvent: (state, action: PayloadAction<string>) => {
            state.events = state.events.filter(e => Object.keys(e)[0] !== action.payload)
        }
    },
})

export const {clearAllEvents, clearEvent} = ContentSlice.actions;

export default ContentSlice;
